import React from "react";
import { PageLayout } from "../components/page-layout";
import ContentCreateEdit from "../components/content/content-create-edit";
import ContentList from "../components/content/content-list";
import { useAuth0 } from "@auth0/auth0-react";
import { GuestHome } from "../components/home/guest-home";
import HelpfulLinks from "../components/home/helpful-links";
import PinnedPosts from "../components/pinned-posts/pinned-post";
import EventCalendar from "../components/events/event-calendar";
import { getContactById } from "../services/contact-service";
import { useEffect, useState } from "react";

export const HomePage = () => {
  const { isAuthenticated, getAccessTokenSilently, user } = useAuth0();
  const [contact, setContact] = useState(null);

  useEffect(() => {
    if (!isAuthenticated && user?.memberId) return;

    const retrieveContact = async () => {
      const token = await getAccessTokenSilently();
      const result = await getContactById(token, user.memberId);

      if (result?.data) {
        const contactData = result.data;
        setContact(contactData);

        const language = contactData.language || "en";

        localStorage.setItem("language", language);
      }
    };

    retrieveContact();
  }, [isAuthenticated, user?.memberId, getAccessTokenSilently]);

  return (
    <PageLayout fullWidth={true}>
      {isAuthenticated && 
        <>
          <PinnedPosts />
          <ContentList />
          <HelpfulLinks user={user}/>
        </>
      }
      {!isAuthenticated && 
        <GuestHome />
      }
    </PageLayout> 
  )
};
